import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

const ROLE_HIERARCHY: Record<string, number> = {
  SUPER_ADMIN: 0,
  ADMIN: 1,
  USER: 2,
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuthStore();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles) {
    const userLevel = ROLE_HIERARCHY[user.role] ?? 99;
    const hasPermission = allowedRoles.some((role) => {
      const requiredLevel = ROLE_HIERARCHY[role] ?? 99;
      return userLevel <= requiredLevel;
    });

    if (!hasPermission) {
      return <Navigate to="/projects" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
